<template>
  <v-dialog max-width="600px" :value="true" @click:outside="$emit('cancel')">
    <v-card class="py-5">
      <v-card-title class="body-1 text-center">
        <v-spacer></v-spacer>
        {{ title }}
        <v-spacer></v-spacer>
      </v-card-title>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="disabled" class="mx-3" color="primary" depressed @click="$emit('accept')">
          {{ acceptText }}
        </v-btn>

        <v-btn v-if="!hideCancel" :disabled="disabled" text class="mx-3" color="primary" @click="$emit('cancel')">
          {{ cancelText}}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Are you sure your want to delete?'
    },
    acceptText: {
      type: String,
      default: 'Ok'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideCancel: {
      type: Boolean,
      default: false
    }
  }  
}
</script>